import Skeleton from "@mui/material/Skeleton";
import { MuiBox } from "components/atoms";
import React from "react";

const LatestTermsModalSkeleton = () => {
  const lineWidths = ["96%", "88%", "92%", "74%", "95%", "82%", "68%"];

  return (
    <MuiBox
      sx={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <MuiBox
        sx={{
          p: "20px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "18px",
        }}
      >
        <Skeleton variant="text" width="58%" height={22} />
        <Skeleton variant="text" width={190} height={22} />

        {[0, 1, 2].map((section) => (
          <MuiBox key={section}>
            <Skeleton variant="text" width={`${24 + section * 5}%`} height={26} />
            {lineWidths.slice(0, section === 2 ? 4 : 3).map((width, index) => (
              <Skeleton
                key={`${section}-${index}`}
                variant="text"
                width={width}
                height={21}
              />
            ))}
          </MuiBox>
        ))}

        <Skeleton variant="text" width="48%" height={22} sx={{ mt: "auto" }} />
      </MuiBox>

      <MuiBox
        sx={{
          bgcolor: "background.gray200",
          p: "16px 20px",
          display: "flex",
          justifyContent: "flex-end",
          borderRadius: "0 0 12px 12px",
        }}
      >
        <Skeleton variant="rounded" width={76} height={40} />
      </MuiBox>
    </MuiBox>
  );
};

export default LatestTermsModalSkeleton;
